import React from 'react';
import { ParagraphText } from 'styling/Typography';
import { ShiftTimelineContainer, ShiftTimelineSegment } from './GlobalView.styled';

type Shift = {
    shiftStart: number; // in minutes since midnight
    minutes: number; // total duration of shift
};

type TaskTimeSpan = {
    start: string; // ISO datetime
    end: string;
};

type Segment = {
    start: number;
    end: number;
    type: 'task' | 'free';
};

const toMinutesSinceMidnight = (isoStr: string): number => {
    const date = new Date(isoStr);
    return date.getHours() * 60 + date.getMinutes();
};

const buildScheduleMap = (
    shift: Shift,
    taskSpans: TaskTimeSpan[]
): Segment[] => {
    const shiftEnd = shift.shiftStart + shift.minutes;
    const segments: Segment[] = [];

    const sortedTasks = taskSpans
        .map((span) => ({
            start: toMinutesSinceMidnight(span.start),
            end: toMinutesSinceMidnight(span.end),
        }))
        .filter((task) => task.end > task.start)
        .sort((a, b) => a.start - b.start);

    let current = shift.shiftStart;

    for (const task of sortedTasks) {
        if (task.start > current) {
            segments.push({ start: current, end: task.start, type: 'free' });
        }
        segments.push({ start: task.start, end: task.end, type: 'task' });
        current = Math.max(current, task.end);
    }

    if (current < shiftEnd) {
        segments.push({ start: current, end: shiftEnd, type: 'free' });
    }

    return segments;
};

const formatHour = (totalMinutes: number) => {
    const hours = Math.floor(totalMinutes / 60);
    return `${hours.toString().padStart(2, '0')}:00`;
};

export const ShiftTimeline: React.FC<{
    shift: Shift;
    todayTaskTimeSpans: TaskTimeSpan[];
}> = ({ shift, todayTaskTimeSpans }) => {
    const segments = buildScheduleMap(shift, todayTaskTimeSpans);
    const shiftEnd = shift.shiftStart + shift.minutes;

    const hourMarks = [];
    for (let min = shift.shiftStart; min <= shiftEnd; min += 60) {
        hourMarks.push(min);
    }

    return (
        <div style={{ fontFamily: 'sans-serif', width: 400, marginTop: 5 }}>
            <ShiftTimelineContainer>
                {segments.map((seg, idx) => {
                    const width = ((seg.end - seg.start) / shift.minutes) * 100;
                    return (
                        <ShiftTimelineSegment key={idx} type={seg.type} width={width.toString()} title={`${seg.type} ${formatHour(seg.start)}–${formatHour(
                            seg.end
                        )}`} />
                    );
                })}
                <div className='line' ></div>
            </ShiftTimelineContainer>

            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                {hourMarks.map((min, i) => (
                    <ParagraphText key={i} >
                        {formatHour(min)}
                    </ParagraphText>
                ))}
            </div>
        </div>
    );
};
